module.exports = __webpack_public_path__ + "static/media/tutorial-map.aa14c726.png";